import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import {
	NavigationPropType,
	PromoBlockPropType,
	RubricPropType
} from 'propTypes/common';

import { Layout } from 'components/Layout';
import MainGridPromoBlocks from 'components/sections/MainGridPromoBlocks';
import MainPageHead from 'components/sections/MainPageHead';
import MainPublicationCardsGrid from 'components/sections/MainPublicationCardsGrid';
import MainSliderEntities from 'components/sections/MainSliderEntities';
import SectionMainPromoBlock from 'components/sections/SectionMainPromoBlock';
import SimilarPersons from 'components/sections/SimilarPersons';
import { InstituteType } from 'propTypes/entities';

const TheatersTemplate = ({
	menu,
	rubric,
	blocks,
	pageText,
	topPromoBlock,
	recommendations
}) => {
	const {
		articles,
		incutGridPromoBlock,
		incutSimplePromoBlock,
		performances,
		persons,
		themes
	} = blocks;

	return (
		<Layout menu={menu} rubric={rubric} topPromoBlock={topPromoBlock}>
			<MainPageHead description={pageText} icon="theater" title="Театр" />

			{!_(performances).isEmpty() && (
				<MainSliderEntities
					entities={performances}
					entityType="movies"
					title="Каталог спектаклей"
					url="/live/theaters/performances"
				/>
			)}

			{!_(articles).isEmpty() && (
				<MainPublicationCardsGrid
					entities={articles}
					position="3/5"
					title="Публикации"
					url="/theaters/articles"
				/>
			)}

			{!_(incutSimplePromoBlock).isEmpty() && (
				<SectionMainPromoBlock blocks={incutSimplePromoBlock} />
			)}

			{!_(themes).isEmpty() && (
				<MainPublicationCardsGrid
					entities={themes}
					position="1/3"
					title="Подборки"
					url="/theaters/themes"
				/>
			)}

			{!_(recommendations).isEmpty() && recommendations?.length > 3 && (
				<MainSliderEntities
					ariaLabel="Рекомендательный блок"
					entities={recommendations}
					entityType="institutes"
					title="Персональные рекомендации"
				/>
			)}

			{!_(incutGridPromoBlock).isEmpty() && (
				<MainGridPromoBlocks blocks={incutGridPromoBlock} />
			)}

			{!_(persons).isEmpty() && (
				<SimilarPersons entities={persons} url="/theaters/persons" />
			)}
		</Layout>
	);
};

TheatersTemplate.propTypes = {
	menu: NavigationPropType.isRequired,
	rubric: RubricPropType.isRequired,
	blocks: PropTypes.shape({
		articles: PropTypes.array,
		incutGridPromoBlock: PropTypes.array,
		incutSimplePromoBlock: PropTypes.array,
		performances: PropTypes.array,
		persons: PropTypes.array,
		themes: PropTypes.array
	}).isRequired,
	pageText: PropTypes.string.isRequired,
	topPromoBlock: PromoBlockPropType,
	recommendations: PropTypes.arrayOf(InstituteType)
};

export default TheatersTemplate;
